import { ArrowBackIcon } from '@chakra-ui/icons';
import {
  Box,
  Center,
  Flex,
  HStack,
  Heading,
  Image,
  Text,
  VStack,
  Wrap,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import usePathNavigate from '../lib/hook/usePathNavigate';
import PhotoButton from '../components/PhotoButton';
import PreviewImageModal from '../components/PreviewImageModal';
import ProgressInfo from '../components/ProgressInfo';
import ProgressDetail from '../components/ProgressDetail';

function ProgressResult() {
  const { pathNavigate, backNavigate } = usePathNavigate();
  const toast = useToast();

  const location = useLocation();
  const [isResult, setIsResult] = useState<boolean>(false);

  const [progressStatus, setProgressStatus] = useState(7);

  console.log(location.state);

  const {
    isOpen: imageIsOpen,
    onClose: imageClose,
    onOpen: imageOpen,
  } = useDisclosure();
  const [previewImage, setPreviewImage] = useState('');
  const onPreviewImage = (previewImage: string) => {
    console.log(previewImage);
    setPreviewImage(previewImage);
    imageOpen();
  };

  return (
    <Box>
      <HStack>
        <Center
          w="100%"
          h="60px"
          bgColor={'white'}
          fontSize="20px"
          borderBottomWidth={'1px'}
          fontWeight={'semibold'}>
          진행현황
        </Center>
        <ArrowBackIcon
          position={'absolute'}
          left={'16px'}
          boxSize={'24px'}
          onClick={() => {
            backNavigate();
          }}
        />
      </HStack>
      {isResult ? (
        <VStack w={'full'}>
          <Image
            src="/assets/images/icn_circle_check.svg"
            mt="158px"
            boxSize={'56px'}
          />
          <Text mt="16px" fontSize={'22px'} fontWeight="semibold">
            접수 정보가 없습니다
          </Text>
          <Text fontSize={'14px'} fontWeight="semibold" color={'#757575'}>
            접수번호 또는 접수자 정보를 확인하세요
          </Text>
        </VStack>
      ) : (
        <Box pb={'36px'}>
          <ProgressInfo status={progressStatus} />
          <Box w={'100%'} h="8px" bg="#f5f6f8" />
          <Box mt={'20px'} mb={'20px'} px={'20px'}>
            <Heading fontSize={'16px'} fontWeight="semibold">
              접수내역
            </Heading>
            <ProgressDetail status={progressStatus} />
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                제품 분류
              </Text>
              <Flex
                w={'full'}
                h={'54px'}
                mt={'8px'}
                px={'10px'}
                bg={'#eeeeee'}
                alignItems={'center'}
                borderRadius={'base'}>
                <Text fontSize={'14px'} fontWeight="semibold" color={'#191600'}>
                  {'테크니카'}
                </Text>
              </Flex>
            </Box>
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                제품명
              </Text>
              <Flex
                w={'full'}
                h={'54px'}
                mt={'8px'}
                px={'10px'}
                bg={'#eeeeee'}
                alignItems={'center'}
                borderRadius={'base'}>
                <Text fontSize={'14px'} fontWeight="semibold" color={'#191600'}>
                  {'마그마 S GTX'}
                </Text>
              </Flex>
            </Box>
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                제품 사이즈
              </Text>
              <Flex
                w={'full'}
                h={'54px'}
                mt={'8px'}
                px={'10px'}
                bg={'#eeeeee'}
                alignItems={'center'}
                borderRadius={'base'}>
                <Text fontSize={'14px'} fontWeight="semibold" color={'#191600'}>
                  {'280'}
                </Text>
              </Flex>
            </Box>
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                접수 사진
              </Text>
              <Box mt={'8px'}>
                <Wrap spacing={'5px'} overflow="visible">
                  {[1, 2, 3, 4].map((photo, index) => (
                    <PhotoButton
                      key={index}
                      slotId={index}
                      imagePath={
                        'https://images.chosun.com/resizer/99cTsh7rNeBkw8_SqnPoLgey_9s=/530x636/smart/cloudfront-ap-northeast-1.images.arcpublishing.com/chosun/OKJAHZMYI6FWI352Q34JMEV3JU.jpg'
                      }
                      onPreviewImage={onPreviewImage}
                    />
                  ))}
                </Wrap>
              </Box>
              <Text mt={'8px'} fontSize={'13px'} fontWeight="semibold">
                완료 사진
              </Text>
              <Box mt={'8px'}>
                <Wrap spacing={'5px'} overflow="visible">
                  {[1, 2, 3, 4].map((photo, index) => (
                    <PhotoButton
                      key={index}
                      slotId={index}
                      imagePath={
                        'https://images.chosun.com/resizer/99cTsh7rNeBkw8_SqnPoLgey_9s=/530x636/smart/cloudfront-ap-northeast-1.images.arcpublishing.com/chosun/OKJAHZMYI6FWI352Q34JMEV3JU.jpg'
                      }
                      onPreviewImage={onPreviewImage}
                    />
                  ))}
                </Wrap>
              </Box>
            </Box>
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                수선 요청 사항
              </Text>
              <Flex
                w={'full'}
                minH={'108px'}
                mt={'8px'}
                py={'12px'}
                px={'10px'}
                bg={'#eeeeee'}
                alignItems={'flex-start'}
                borderRadius={'base'}>
                <Text fontSize={'14px'} fontWeight="medium" color={'#191600'}>
                  {
                    '신발을 좀 거칠게 신어서 그런지 여기저기 찢어진 것 같아요. 수선 가능할까요?'
                  }
                </Text>
              </Flex>
            </Box>
            <Box mt={'16px'}>
              <Text fontSize={'13px'} fontWeight="semibold">
                접수자 및 배송정보
              </Text>
              <Flex
                flexDirection={'column'}
                justifyContent={'center'}
                w={'full'}
                mt={'8px'}
                py={'12px'}
                px={'10px'}
                bg={'#eeeeee'}
                borderRadius={'base'}
                gap={'10px'}>
                <Text fontSize={'13px'} fontWeight="medium" color={'#212121'}>
                  {'김용기'}
                </Text>
                <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
                  {'서울 도봉구 우이천로 367 501동 1195호'}
                </Text>
                <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
                  {'010-3837-5123'}
                </Text>
                <Text fontSize={'13px'} fontWeight="medium" color={'#191600'}>
                  {
                    '공동현관 출입시 세대벨호출 또는 부재시 경비실에 출입 요청 하여야 합니다. 배송은 세대 문앞에서 처리 요청합니다.'
                  }
                </Text>
              </Flex>
            </Box>
          </Box>
        </Box>
      )}
      <PreviewImageModal
        isOpen={imageIsOpen}
        onClose={imageClose}
        previewImage={previewImage}
      />
      <form
        action="https://info.sweettracker.co.kr/tracking/5"
        method="post"
        id="invoiceForm"
        target="invoiceWin">
        <input type="hidden" id="t_key" name="t_key" />
        <input type="hidden" name="t_code" id="t_code" />
        <input type="hidden" name="t_invoice" id="t_invoice" />
      </form>
    </Box>
  );
}

export default ProgressResult;
